import React, { useEffect } from 'react';
import { Alert, Button } from 'react-bootstrap';

const LessonLayout = ({ title, description, children, lessonNumber }) => {
  useEffect(() => {
    console.log(`📖 Viewing: Lesson ${lessonNumber} - ${title}`);
    console.log(`📝 Description: ${description}`);
    console.log('💡 TIP: Watch the console for detailed logs!');
    
    return () => {
      console.log(`👋 Leaving: Lesson ${lessonNumber} - ${title}`);
    };
  }, [title, description, lessonNumber]);

  const handleConsoleAlert = () => {
    alert('📖 Console is open! Press F12 (or Cmd+Option+I on Mac) if you don\'t see it.');
    console.log('✅ User clicked "View Console" button');
  };

  return (
    <div className="lesson-container">
      <div className="d-flex justify-content-between align-items-start mb-3">
        <div>
          <h2>
            <span className="lesson-number">{lessonNumber}</span>
            {title}
          </h2>
          <p className="text-muted">{description}</p>
        </div>
      </div>
      
      <Alert variant="info" className="console-alert">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <strong>💡 Learning Tip:</strong> Open Console (F12) to see detailed outputs and logs!
          </div>
          <Button 
            variant="light" 
            size="sm" 
            onClick={handleConsoleAlert}
          >
            View Console
          </Button>
        </div>
      </Alert>

      <div className="lesson-content">
        {children}
      </div>
    </div>
  );
};

export default LessonLayout;
